module.exports = {"slides":[{"icon":"f5_2_1","color":"turquoise","txt":"f5_slid_txt_1"},{"icon":"f5_2_2","color":"turquoise","txt":"f5_slid_txt_2"},{"icon":"f5_2_3","color":"turquoise","txt":"f5_slid_txt_3"},{"icon":"f5_2_4","color":"turquoise","txt":"f5_slid_txt_4"},{"icon":"f5_2_5","color":"turquoise","txt":"f5_slid_txt_5"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/fact_5_s.json
// module id = YXSL
// module chunks = 1